import { MenuItems, MenuGroups } from './menu-items';

// The single Portal menu (CHAT-855).
//
// This replaces the former three-way fork (menu / botMenu / customerMenu) that the sidebar
// swapped between depending on bot count and URL. Under the 1-bot-per-account masking policy
// org-level and bot-level are the same context, so one list serves every scope.
//
// Shape: a flat list, one level of submenu, module + permission per item. That is UCP's
// SidebarItem[] shape, so the Kendo Drawer port in CHAT-857 is a presentational swap.
// Do not deepen the nesting.
//
// Order: SuperAdmin-only rows pinned at the top so the permission boundary is self-evident,
// then workspaces by frequency of use, then grouped configuration, then Settings last.
//
// Items are filtered at render time by MenuService (privilege + tier, recursively), so this
// array is the full superset in display order.
//
// Deprecated rows (Forms, Audience, Conversations, Knowledge Base, Bots, Home, Getting
// Started, Pages/Lab, Operator Chat, and the duplicate Connectors / Admin Users rows) are
// no longer listed here. Most of their routes still resolve; the Pages/Lab ones were
// deleted in CHAT-783. See menu-items.ts for the per-item notes.
export const menu = [
  // SuperAdmin only
  MenuItems.Partners,
  MenuGroups.Admin,

  // Workspaces
  MenuItems.BotDashboard,
  MenuItems.ChatQueue,
  MenuGroups.Channels,

  // Configuration
  MenuGroups.ConversationFlow,
  MenuGroups.ConversationRouting,
  MenuGroups.BotSkills,
  // A Reports group is reserved here, but deliberately not rendered until its contents are
  // decided - an empty group is worse than no group.
  MenuGroups.Logs,
  MenuGroups.Settings,
];
